import { databaseStore } from ".";

export const setResultsData = (gameId, resultsData) => {
	databaseStore.update((s) => {
		s.resultsData[gameId] = resultsData;
	})
}

export const setTeamsData = (teamsData) => {
	databaseStore.update((s) => {
		s.teamsData = teamsData;
	})
}

export const addToTeamsData = (teamId, teamData) => {
	databaseStore.update((s) => {
		s.teamsData[teamId] = teamData;
	})
}

export const setIsLoading = (isLoading) => {
	databaseStore.update((s) => {
		s.isLoading = isLoading;
	})
}
